import React, { useState, useEffect } from 'react'

import { Box, Typography, keyframes } from '@mui/material'
interface Props {
  isLoading: boolean
}

const bounceAnimation = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`

const LoadingMessages = ({ isLoading }: Props) => {
  const messages = [
    'Analyzing your question and preparing a precise legal reply...',
    'Searching through law files to bring you the best answer...',
    'Finding the right legal points just for you. Hold on a moment...',
    'Compiling accurate legal insights tailored to your query. This won’t take long..',
    'Reading between the legal lines to assist you better...',
    'Drafting a well-informed legal response to your request...',
    'Carefully preparing your legal response with attention to detail...',
    'Your legal assistant is working on a personalized, accurate answer...',
    ' We’ll have your answer soon.',
  ]

  const [currentMessage, setCurrentMessage] = useState(messages[0])

  useEffect(() => {
    if (!isLoading) return // Don't run if not loading

    let currentIndex = 0
    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % messages.length // Loop back to start
      setCurrentMessage(messages[currentIndex])
    }, 3000) // Change message every 3 seconds

    return () => {
      clearInterval(interval)
    } // Cleanup on unmount
  }, [isLoading, messages])

  if (!isLoading) return null

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 1,
        borderRadius: 1,
        bgcolor: '#777',
        color: '#fff',
        borderLeft: '4px solid',
        borderColor: 'primary.main',
      }}
    >
      <Typography variant='body1'>{currentMessage}</Typography>
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: 8,
            height: 8,
            bgcolor: 'primary.main',
            borderRadius: '50%',
            animation: `${bounceAnimation} 1s infinite`,
            animationDelay: `${i * 0.2}s`,
          }}
        />
      ))}
    </Box>
  )
}

export default LoadingMessages
